import ProductGridPlaceholder from '@core-ui/product-grid-placeholder';
import useColorSwatches from '../../../hooks/features/useColorSwatches';
import useStarRatings from '../../../hooks/features/useStarRatings';
import useBRRedesign from '../../../hooks/features/useBRRedesign';
import ProductGridPlaceholderWrapper from '../styled/ProductGridPlaceholderWrapper';

const getWindowWidth = () => {
  return typeof window !== 'undefined' && window?.innerWidth;
}

const getNumberOfPlaceholders = isBrRedesignEnabled => {
  if(isBrRedesignEnabled && getWindowWidth() >= 768) return 9;
  return 8;
}

const GridPlaceholder = () => {
  const isColorSwatchesEnabled = useColorSwatches();
  const isStarRatingsEnabled = useStarRatings();
  const isBrRedesignEnabled = useBRRedesign();

  const numberOfPlaceholders = getNumberOfPlaceholders(isBrRedesignEnabled);

  return (
    <ProductGridPlaceholderWrapper isBrRedesignEnabled={isBrRedesignEnabled}>
      <ProductGridPlaceholder
        numberOfPlaceholders={numberOfPlaceholders}
        showColorSwatchesPlaceholder={isColorSwatchesEnabled}
        showStarRatingsPlaceholder={isStarRatingsEnabled}
      />
    </ProductGridPlaceholderWrapper>
  );
};

export default GridPlaceholder;
